import { BaseState } from '../../../../../entities/BaseState';
import { ILoginUser, LoginUser } from '../../../../Login/entities';
import IUserSelectModalProps from '../entities/IUserSelectModalProps';
import { createSelector } from 'reselect';

const getUserSelectModalDataSelector = (state: BaseState, props: IUserSelectModalProps) =>
	state.modals.data.get(props.modalId, null);

const getUserSelectModalData = createSelector(
	[getUserSelectModalDataSelector],
	(data: any | null) => data
);

const getCurrentUserSelector = (state: BaseState) => state.user.data;

const getCurrentUser = createSelector([getCurrentUserSelector], data => data.toJS() as ILoginUser);

export { getUserSelectModalData, getUserSelectModalDataSelector, getCurrentUser };
